import { Product } from "@/types/product";
import { Star } from "lucide-react";

interface SearchResultItemProps {
  product: Product;
  onSelect: (product: Product) => void;
  searchQuery?: string;
}

const SearchResultItem = ({ product, onSelect, searchQuery }: SearchResultItemProps) => {
  const highlightText = (text: string) => {
    if (!searchQuery || searchQuery.length < 2) return text;
    
    const regex = new RegExp(`(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? (
        <span key={index} className="bg-yellow-200 dark:bg-yellow-800 rounded px-0.5">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <div
      className="p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b last:border-b-0 transition-colors duration-200"
      onClick={() => onSelect(product)}
    >
      <div className="flex items-center gap-3">
        <img
          src={product.image_url}
          alt={product.title}
          className="w-12 h-12 object-cover rounded"
        />
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <div>
              <p className="font-medium">{highlightText(product.title)}</p>
              <p className="text-sm text-gray-500">{highlightText(product.slug)}</p>
              <div className="flex items-center gap-2">
                <p className="text-sm text-gray-600 dark:text-gray-300">
                  €{product.price.toFixed(2)}
                </p>
                <div className="flex items-center gap-1">
                  <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  <span className="text-sm text-gray-600">
                    {product.average_rating.toFixed(1)}
                  </span>
                  <span className="text-sm text-gray-400">
                    ({product.rating_amount})
                  </span>
                </div>
              </div>
            </div>
            <div className="text-sm text-gray-400 ml-4">
              EAN: {highlightText(product.ean)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResultItem;